import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <Section className="bg-[#0f0f0f]" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-14">
          {/* For You */}
          <div className="bg-[#111111] border border-[#22C55E]/20 rounded-2xl p-8" data-id="element-15">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-16">
              <span className="bg-[#22C55E]/10 p-2 rounded-full" data-id="element-17">
                <Check className="w-6 h-6 text-[#22C55E]" data-id="element-18" />
              </span>
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-19">
              {['Estás ocupado de verdad', 'Quieres algo rápido y serio', 'Odias lo místico pero te importa rendir', 'Quieres control sin volverte otra persona'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-20">
                  <Check className="w-5 h-5 text-[#22C55E] shrink-0 mt-0.5" data-id="element-21" />
                  <span data-id="element-22">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-[#111111] border border-[#EF4444]/20 rounded-2xl p-8" data-id="element-23">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-24">
              <span className="bg-[#EF4444]/10 p-2 rounded-full" data-id="element-25">
                <X className="w-6 h-6 text-[#EF4444]" data-id="element-26" />
              </span>
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-27">
              {['Buscas espiritualidad o manifestación', 'Quieres una solución profunda tipo terapia (esto es operativo)', 'No estás dispuesto a hacer 90 segundos cuando estás prendido'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-28">
                  <X className="w-5 h-5 text-[#EF4444] shrink-0 mt-0.5" data-id="element-29" />
                  <span data-id="element-30">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}